export const colorGroups = [
  {
    wheelIndex: 0,
    name: 'redColors',
    type: 'warm',
    values: [
      {
        name: 'Red',
        hex: 'FF0000'
      },
      {
        name: 'LightSalmon',
        hex: 'FFA07A'
      },
      {
        name: 'Salmon',
        hex: 'FA8072'
      },
      {
        name: 'DarkSalmon',
        hex: 'E9967A'
      },
      {
        name: 'LightCoral',
        hex: 'F08080'
      },
      {
        name: 'IndianRed',
        hex: 'CD5C5C'
      },
      {
        name: 'Crimson',
        hex: 'DC143C'
      },
      {
        name: 'Firebrick',
        hex: 'B22222'
      },
      {
        name: 'DarkRed',
        hex: '8B0000'
      }
    ]
  },
  {
    wheelIndex: 1,
    name: 'orangeColors',
    type: 'warm',
    values: [
      {
        name: 'Orange',
        hex: 'FFA500'
      },
      {
        name: 'OrangeRed',
        hex: 'FF4500'
      },
      {
        name: 'Tomato',
        hex: 'FF6347'
      },
      {
        name: 'Coral',
        hex: 'FF7F50'
      },
      {
        name: 'DarkOrange',
        hex: 'FF8C00'
      }
    ]
  },
  {
    wheelIndex: 2,
    name: 'yellowColors',
    type: 'warm',
    values: [
      {
        name: 'Yellow',
        hex: 'FFFF00'
      },
      {
        name: 'LightYellow',
        hex: 'FFFFE0'
      },
      {
        name: 'LemonChiffon',
        hex: 'FFFACD'
      },
      {
        name: 'LightGoldenrodYellow ',
        hex: 'FAFAD2'
      },
      {
        name: 'PapayaWhip',
        hex: 'FFEFD5'
      },
      {
        name: 'Moccasin',
        hex: 'FFE4B5'
      },
      {
        name: 'PeachPuff',
        hex: 'FFDAB9'
      },
      {
        name: 'PaleGoldenrod',
        hex: 'EEE8AA'
      },
      {
        name: 'Khaki',
        hex: 'F0E68C'
      },
      {
        name: 'DarkKhaki',
        hex: 'BDB76B'
      },
      {
        name: 'Gold',
        hex: 'FFD700'
      }
    ]
  },
  {
    wheelIndex: 3,
    name: 'greenColors',
    type: 'cool',
    values: [
      {
        name: 'Green',
        hex: '008000'
      },
      {
        name: 'DarkOliveGreen',
        hex: '556B2F'
      },
      {
        name: 'Olive',
        hex: '808000'
      },
      {
        name: 'OliveDrab',
        hex: '6B8E23'
      },
      {
        name: 'YellowGreen',
        hex: '9ACD32'
      },
      {
        name: 'LimeGreen',
        hex: '32CD32'
      },
      {
        name: 'Lime',
        hex: '00FF00'
      },
      {
        name: 'LawnGreen',
        hex: '7CFC00'
      },
      {
        name: 'Chartreuse',
        hex: '7FFF00'
      },
      {
        name: 'GreenYellow',
        hex: 'ADFF2F'
      },
      {
        name: 'SpringGreen',
        hex: '00FF7F'
      },
      {
        name: 'MediumSpringGreen ',
        hex: '00FA9A'
      },
      {
        name: 'LightGreen',
        hex: '90EE90'
      },
      {
        name: 'PaleGreen',
        hex: '98FB98'
      },
      {
        name: 'DarkSeaGreen',
        hex: '8FBC8F'
      },
      {
        name: 'MediumAquamarine',
        hex: '66CDAA'
      },
      {
        name: 'MediumSeaGreen',
        hex: '3CB371'
      },
      {
        name: 'SeaGreen',
        hex: '2E8B57'
      },
      {
        name: 'ForestGreen',
        hex: '228B22'
      },
      {
        name: 'DarkGreen',
        hex: '006400'
      }
    ]
  },
  {
    wheelIndex: 4,
    name: 'blueColors',
    type: 'cool',
    values: [
      {
        name: 'Blue',
        hex: '0000FF'
      },
      {
        name: 'LightSteelBlue',
        hex: 'B0C4DE'
      },
      {
        name: 'PowderBlue',
        hex: 'B0E0E6'
      },
      {
        name: 'LightBlue',
        hex: 'ADD8E6'
      },
      {
        name: 'SkyBlue',
        hex: '87CEEB'
      },
      {
        name: 'LightSkyBlue',
        hex: '87CEFA'
      },
      {
        name: 'DeepSkyBlue',
        hex: '00BFFF'
      },
      {
        name: 'DodgerBlue',
        hex: '1E90FF'
      },
      {
        name: 'CornflowerBlue',
        hex: '6495ED'
      },
      {
        name: 'SteelBlue',
        hex: '4682B4'
      },
      {
        name: 'RoyalBlue',
        hex: '4169E1'
      },
      {
        name: 'MediumBlue',
        hex: '0000CD'
      },
      {
        name: 'DarkBlue',
        hex: '00008B'
      },
      {
        name: 'Navy',
        hex: '000080'
      },
      {
        name: 'MidnightBlue',
        hex: '191970'
      }
    ]
  },
  {
    wheelIndex: 5,
    name: 'violetColors',
    type: 'cool',
    values: [
      {
        name: 'Violet',
        hex: 'EE82EE'
      },
      {
        name: 'Purple',
        hex: '800080'
      },
      {
        name: 'Lavender',
        hex: 'E6E6FA'
      },
      {
        name: 'Thistle',
        hex: 'D8BFD8'
      },
      {
        name: 'Plum',
        hex: 'DDA0DD'
      },
      {
        name: 'Orchid',
        hex: 'DA70D6'
      },
      {
        name: 'Fuchsia',
        hex: 'FF00FF'
      },
      {
        name: 'Magenta',
        hex: 'FF00FF'
      },
      {
        name: 'MediumOrchid',
        hex: 'BA55D3'
      },
      {
        name: 'MediumPurple',
        hex: '9370DB'
      },
      {
        name: 'BlueViolet',
        hex: '8A2BE2'
      },
      {
        name: 'DarkViolet',
        hex: '9400D3'
      },
      {
        name: 'DarkOrchid',
        hex: '9932CC'
      },
      {
        name: 'DarkMagenta',
        hex: '8B008B'
      },
      {
        name: 'Indigo',
        hex: '4B0082'
      },
      {
        name: 'DarkSlateBlue',
        hex: '483D8B'
      },
      {
        name: 'SlateBlue',
        hex: '6A5ACD'
      },
      {
        name: 'MediumSlateBlue ',
        hex: '7B68EE'
      }
    ]
  },
  {
    name: 'pinkColors',
    type: 'warm',
    values: [
      {
        name: 'Pink',
        hex: 'FFC0CB'
      },
      {
        name: 'LightPink',
        hex: 'FFB6C1'
      },
      {
        name: 'HotPink',
        hex: 'FF69B4'
      },
      {
        name: 'DeepPink',
        hex: 'FF1493'
      },
      {
        name: 'PaleVioletRed',
        hex: 'DB7093'
      },
      {
        name: 'MediumVioletRed',
        hex: 'C71585'
      }
    ]
  },
  {
    name: 'cyanColors',
    type: 'cool',
    values: [
      {
        name: 'Cyan',
        hex: '00FFFF'
      },
      {
        name: 'Aqua',
        hex: '00FFFF'
      },
      {
        name: 'LightCyan',
        hex: 'E0FFFF'
      },
      {
        name: 'PaleTurquoise',
        hex: 'AFEEEE'
      },
      {
        name: 'Aquamarine',
        hex: '7FFFD4'
      },
      {
        name: 'Turquoise',
        hex: '40E0D0'
      },
      {
        name: 'MediumTurquoise',
        hex: '48D1CC'
      },
      {
        name: 'DarkTurquoise',
        hex: '00CED1'
      },
      {
        name: 'LightSeaGreen',
        hex: '20B2AA'
      },
      {
        name: 'CadetBlue',
        hex: '5F9EA0'
      },
      {
        name: 'DarkCyan',
        hex: '008B8B'
      },
      {
        name: 'Teal',
        hex: '008080'
      }
    ]
  },
  {
    name: 'brownColors',
    type: 'dark',
    values: [
      {
        name: 'Brown',
        hex: 'A52A2A'
      },
      {
        name: 'Cornsilk',
        hex: 'FFF8DC'
      },
      {
        name: 'BlanchedAlmond',
        hex: 'FFEBCD'
      },
      {
        name: 'Bisque',
        hex: 'FFE4C4'
      },
      {
        name: 'NavajoWhite',
        hex: 'FFDEAD'
      },
      {
        name: 'Wheat',
        hex: 'F5DEB3'
      },
      {
        name: 'Burlywood',
        hex: 'DEB887'
      },
      {
        name: 'Tan',
        hex: 'D2B48C'
      },
      {
        name: 'RosyBrown',
        hex: 'BC8F8F'
      },
      {
        name: 'SandyBrown',
        hex: 'F4A460'
      },
      {
        name: 'Goldenrod',
        hex: 'DAA520'
      },
      {
        name: 'DarkGoldenrod',
        hex: 'B8860B'
      },
      {
        name: 'Peru',
        hex: 'CD853F'
      },
      {
        name: 'Chocolate',
        hex: 'D2691E'
      },
      {
        name: 'SaddleBrown',
        hex: '8B4513'
      },
      {
        name: 'Sienna',
        hex: 'A0522D'
      },
      {
        name: 'Maroon',
        hex: '800000'
      }
    ]
  },
  {
    name: 'whiteColors',
    type: 'light',
    values: [
      {
        name: 'White',
        hex: 'FFFFFF'
      },
      {
        name: 'Snow',
        hex: 'FFFAFA'
      },
      {
        name: 'Honeydew',
        hex: 'F0FFF0'
      },
      {
        name: 'MintCream',
        hex: 'F5FFFA'
      },
      {
        name: 'Azure',
        hex: 'F0FFFF'
      },
      {
        name: 'AliceBlue',
        hex: 'F0F8FF'
      },
      {
        name: 'GhostWhite',
        hex: 'F8F8FF'
      },
      {
        name: 'WhiteSmoke',
        hex: 'F5F5F5'
      },
      {
        name: 'Seashell',
        hex: 'FFF5EE'
      },
      {
        name: 'Beige',
        hex: 'F5F5DC'
      },
      {
        name: 'OldLace',
        hex: 'FDF5E6'
      },
      {
        name: 'FloralWhite',
        hex: 'FFFAF0'
      },
      {
        name: 'Ivory',
        hex: 'FFFFF0'
      },
      {
        name: 'AntiqueWhite',
        hex: 'FAEBD7'
      },
      {
        name: 'Linen',
        hex: 'FAF0E6'
      },
      {
        name: 'LavenderBlush',
        hex: 'FFF0F5'
      },
      {
        name: 'MistyRose',
        hex: 'FFE4E1'
      }
    ]
  },
  {
    name: 'grayColors',
    type: 'dark',
    values: [
      {
        name: 'Gray',
        hex: '808080'
      },
      {
        name: 'Gainsboro',
        hex: 'DCDCDC'
      },
      {
        name: 'LightGray',
        hex: 'D3D3D3'
      },
      {
        name: 'Silver',
        hex: 'C0C0C0'
      },
      {
        name: 'DarkGray',
        hex: 'A9A9A9'
      },
      {
        name: 'DimGray',
        hex: '696969'
      },
      {
        name: 'LightSlateGray',
        hex: '778899'
      },
      {
        name: 'SlateGray',
        hex: '708090'
      },
      {
        name: 'DarkSlateGray',
        hex: '2F4F4F'
      },
      {
        name: 'Black',
        hex: '000000'
      }
    ]
  }
]

export const rybColorWheel = [
  'rgb(255, 255, 255)',
  'rgb(255, 0, 0)', // red
  'rgb(0, 255, 0)', // green
  'rgb(255, 165, 0)', // orange
  'rgb(0, 0, 255)', // blue
  'rgb(255, 255, 0)', // yellow
  'rgb(128, 0, 128)', // purple

  'rgb(227, 66, 52)', // vermilion
  'rgb(127, 255, 212)', // aquamarine
  'rgb(255, 191, 0)', // amber
  'rgb(75, 0, 130)', // indigo
  'rgb(127, 255, 0)', // chartreuse
  'rgb(255, 0, 255)' // magenta
]

export function getColorByIndex (i) {
  const reds = colorGroups[0]
  const oranges = colorGroups[1]
  const yellows = colorGroups[2]
  const greens = colorGroups[3]
  const blues = colorGroups[4]
  const violets = colorGroups[5]

  const groups = [reds, greens, oranges, blues, yellows, violets]
  const bigestGroupLength = groups.reduce((max, group) => {
    return Math.max(max, group.values.length)
  }, 0)
  const len = groups.length * bigestGroupLength

  if (i >= len) return randomColorHex()

  const colors = []

  for (let i = 0; i < len; i += 1) {
    const row = Math.floor(i / groups.length)
    const col = i % groups.length

    try {
      colors.push(groups[row].values[col].hex)
    } catch (err) {
      // console.error(err);
    }
  }

  return `#${colors[i]}`
}

export function randomColorHex () {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export function randomColorRGB () {
  let num = Math.round(0xffffff * Math.random())
  let r = num >> 16
  let g = num >> 8 & 255
  let b = num & 255
  return 'rgb(' + r + ', ' + g + ', ' + b + ')'
}



// WEBPACK FOOTER //
// ./src/utils/Color.js